import { render, staticRenderFns } from "./NewPressCard.vue?vue&type=template&id=090d7c66&scoped=true&"
import script from "./NewPressCard.vue?vue&type=script&lang=ts&"
export * from "./NewPressCard.vue?vue&type=script&lang=ts&"
import style0 from "./NewPressCard.vue?vue&type=style&index=0&id=090d7c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d7c66",
  null
  
)

export default component.exports